import React from 'react'
import AlamatService from '../Service/alamatService'
import FormInput from './formInput'
import LokasiService from '../Service/lokasiService'

import ModalHapus from './modalHapus'
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap'
import ModalHapusList from './modalHapusList'
import { config } from '../Config/config'

export default class index extends React.Component {
    alamatModel = {
        label: "",
        recipent: "",
        recipent_phone_number: "",
        location_id: "",
        postal_code: "",
        address: "",
        biodata_id: localStorage.getItem(config.biodata_id),
    }

    constructor() {
        super()
        this.state = {
            List: [],
            ListLokasi: [],
            Model: this.alamatModel,
            errors: {},
            showModalDel: false,
            TotalPage: 0,
            count: 0,
            filter: {
                search: "",
                order: "",
                page: '1',
                pageSize: '5',
                urut: 'recipent',
                biodata_id: localStorage.getItem(config.biodata_id)
            },

            ListDelete: []
        }
    }

    loadList = async () => {
        const respon = await AlamatService.getAllFilter(this.state.filter)
        const responLokasi = await LokasiService.getAll()
        const responCount = await AlamatService.countData(this.state.filter)


        if (respon.success) {
            let count = 0
            if (responCount.result !=undefined) {
                count = responCount.result.count
            }
            // let count = responCount.result.count
            this.setState({
                List: respon.result,
                ListLokasi: responLokasi.result,
                TotalPage: Math.ceil(count / this.state.filter.pageSize)
            })

        }


    }

    componentDidMount() {
        this.loadList()
    }

    // //untuk filter
    filterHandler = field => ({ target: { value } }) => {
        this.setState({
            filter: {
                ...this.state.filter,
                [field]: value
            }
        })
    }

    // //untuk merubah nama dan description di form input
    changeHandler = name => ({ target: { value } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [name]: value
            }
        })
    }

    //untuk button submit
    saveHandler = async () => {
        if (this.handleValidation()) {
            if (this.state.Mode == "UBAH ALAMAT") {
                const respon = await AlamatService.EditData(this.state.Model)
                if (respon.success) {
                    alert("Success Update Data")
                    this.loadList()
                    this.setState({
                        Model: this.alamatModel,
                        showModal: false
                    })
                }
            }
            else {
                const respon = await AlamatService.addData(this.state.Model)
                if (respon.success) {
                    alert("Succes Save Data")
                    this.loadList()
                    this.setState({
                        Model: this.alamatModel,
                        showModal: false
                    })
                }
            }
        } else {
            alert("Form has errors.")
        }
    }




    //untuk modal
    editHandler = async (id) => {
        console.log(id)
        const respon = await AlamatService.getById(id)

        console.log(respon)
        this.setState({
            Mode: "UBAH ALAMAT",
            showModal: true
        })
        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }
    }

    createHandler = () => {
        this.setState({
            Mode: "TAMBAH ALAMAT",
            showModal: true,
            Model: this.alamatModel
        })
        console.log(this.state.showModal)
    }

    cancelHandler = () => {
        this.setState({
            Mode: "",
            showModal: false,
            showModalDel: false,
            showModalDel2: false
        })
    }

    checkedHandler = field => ({ target: { checked } }) => {
        this.setState({
            Model: {
                ...this.state.Model,
                [field]: checked
            }
        })
    }

    // button checkbox delete
    deleteCheck = async (id) => {
        const { ListDelete } = this.state
        const respon = await AlamatService.getById(id)


        if (respon.success) {
            var data = {
                _id: respon.result._id,
                address: respon.result.address,
                label : respon.result.label
            }


            let index = ListDelete.findIndex(x => x._id === data._id && x.address === data.address
                && x.label === data.label)

            if (index == -1) {
                ListDelete.push(data)
            } else {
                ListDelete.splice(index, 1)
            }

            console.log(ListDelete)

            this.setState({
                Model: respon.result
            })
        }
    }

    // //button awal List delete
    deleteHandlerr = () => {
        this.setState({
            showModalDel2: true
        })
    }

    // //button modal List yakin delete
    deleteHandlerr2 = async () => {
        let tmplist = this.state.ListDelete
        console.log(tmplist)

        for (let i = 0; i < tmplist.length; i++) {
            const respon = await AlamatService.DeleteData(tmplist[i])
            if (respon.success) {
                this.loadList()
            }
        }
        this.setState({
            showModalDel2: false
        })

    }

    // //button awal delete
    deleteHandler = async (id) => {
        const respon = await AlamatService.getById(id)
        this.setState({
            showModalDel: true
        })
        if (respon.success) {
            this.setState({
                Model: respon.result
            })
        }

    }

    // //button modal yakin delete
    deleteHandler2 = async () => {
        let tmpID = this.state.Model
        console.log(tmpID)
        const respon = await AlamatService.DeleteData(tmpID)
        // console.log(this.state.Model._id)
        if (respon.success) {
            alert("succes Delete Data")
            this.loadList()
            this.setState({
                showModalDel: false
            })
        }
    }


    // // untuk validasi
    handleValidation() {
        let fields = this.state.Model
        let errors = {};
        let formIsValid = true;

        //Name
        if (!fields["recipent"]) {
            formIsValid = false;
            errors["recipent"] = "Nama Penerima harus diisi";
        }

        if (!fields["label"]) {
            formIsValid = false;
            errors["label"] = "Label Alamat harus diisi";
        }

        if (!fields["recipent_phone_number"]) {
            formIsValid = false;
            errors["number"] = "Nomor Hp Penerima harus diisi";
        }

        if (!fields["location_id"]) {
            formIsValid = false;
            errors["lokasi"] = "Kecamatan/Kota harus dipilih";
        }

        if (!fields["address"]) {
            formIsValid = false;
            errors["address"] = "Alamat harus dipilih";
        }


        this.setState({ errors: errors });
        return formIsValid;
    }

    // //untuk membuat sort
    sortHandler = () => {
        let sort = ''
        sort = this.state.filter.order == '' ? '1' : '-1'
        sort = this.state.filter.order == '-1' ? '1' : '-1'

        this.setState({
            filter: {
                ...this.state.filter,
                ['order']: sort
            }
        }, () => this.loadList())
    }

    // //untuk mengambil total halaman
    pageSizeHandler = (size) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["pageSize"]: size
            }
        }, () => this.loadList())
    }

    // //untuk membuat nomor halaman, ke hamalan 1, 2 dst 
    changePageHandler = (number) => {
        this.setState({
            filter: {
                ...this.state.filter,
                ["page"]: number
            }
        }, () => this.loadList())
    }

    renderPagination() {
        let item = []
        for (let number = 1; number <= this.state.TotalPage; number++) {
            item.push(
                <PaginationItem key={number} active={number === this.state.filter}>
                    <PaginationLink onClick={() => this.changePageHandler(number)}>
                        {number}
                    </PaginationLink>
                </PaginationItem>
            )
        }
        return (
            <Pagination>{item}</Pagination>
        )
    }



    render() {
        const { List } = this.state
        return (
            <div class="container">
                {/* {JSON.stringify(this.state.filter)} */}
                <div >

                <div class="content">

                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="card-box">

                                                <div class="form-group row float-right">
                                                    <h4 class="col-form-label col-md-5 mr-2">Urutkan: </h4>

                                                    <select class="form-select btn-outline-primary" onChange={this.filterHandler("urut")}>
                                                        <option value="recipent" >Nama</option>
                                                        <option value="address" >Alamat</option>
                                                    </select>

                                                </div>

                                                <div class="input-group col-6 mb-1 float-left">
                                                    <input class="form-control rounded-left" type="text" placeholder="Cari alamat atau nama penerima" onChange={this.filterHandler("search")} />
                                                    <div class="input-group-append"  onClick={this.loadList}>
                                                        <button class="btn btn-primary rounded-right" type="button">

                                                            <i class="fa fa-search"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <br /> <br /> <br />


                                                <div class="card-header">
                                                    <button type="button" class="btn btn-primary float-right" onClick={this.createHandler}>Tambah</button>

                                                    <div class="float-right mr-1">

                                                        <button type="button" class="btn btn-outline-success dropdown-toggle" data-toggle="dropdown" aria-expanded="true">
                                                            Show Data
                                                            </button>

                                                        <ul class="dropdown-menu">
                                                            <li><a href="#"  onClick={() => this.pageSizeHandler('5')} className="dropdown-item">5</a></li>
                                                            <li><a href="#" onClick={() => this.pageSizeHandler('10')} className="dropdown-item">10</a></li>
                                                            <li><a href="#" onClick={() => this.pageSizeHandler('20')} className="dropdown-item">20</a></li>
                                                            <li><a href="#" onClick={() => this.pageSizeHandler('30')} className="dropdown-item">30</a></li>
                                                        </ul>

                                                    </div>


                                                    <div class="float-right mr-1">

                                                        <button type="button" class="btn btn-outline-warning" onClick={this.sortHandler} >
                                                            Asc / Dsc
                                                            </button>

                                                    </div>



                                                    <button type="button" class="btn btn-danger" onClick={() => this.deleteHandlerr(this.state.ListDelete)}>Hapus</button>
                                                </div>


                                                <div class="card-body p-0">
                                                    <div class="table-responsive">
                                                        <table class="table mb-0">
                                                            <thead class="d-none">
                                                                <tr>
                                                                    <th></th>
                                                                    <th></th>
                                                                    <th class="float-right"></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    List.map(data => {
                                                                        return (
                                                                            <tr >
                                                                                <td class="text-left">
                                                                                    <input class="form-check-input mt-3 ml-1" type="checkbox" onClick={() => this.deleteCheck(data._id)}/>
                                                                                </td>

                                                                                <td>
                                                                                    <h2>
                                                                                        {data.label}
                                                                                        <span>{data.recipent}, {data.phone_number}</span>
                                                                                        <span>{data.address}, {data.lokasi} </span>
                                                                                    </h2>

                                                                                </td>
                                                                                <td class="text-right">
                                                                                    <button class="btn btn-outline-primary take-btn mr-1"onClick={() => this.editHandler(data._id)} >Ubah</button>
                                                                                    <button class="btn btn-outline-danger take-btn" onClick={() => this.deleteHandler(data._id)}>Hapus</button>
                                                                                </td>
                                                                            </tr>

                                                                        )
                                                                    })
                                                                }

                                                            </tbody>
                                                        </table>
                                                        <div class="float-right mt-2">
                                                            {this.renderPagination()}
                                                        </div>



                                                        <FormInput
                                                            changeHandler={this.changeHandler}
                                                            saveHandler={this.saveHandler}
                                                            Model={this.state.Model}
                                                            CreateHandler={this.createHandler}
                                                            ShowModal={this.state.showModal}
                                                            EditHandler={this.editHandler}
                                                            CancelHandler={this.cancelHandler}
                                                            errors={this.state.errors}
                                                            Mode={this.state.Mode}
                                                            ListLokasi={this.state.ListLokasi}
                                                            
                                                        />
                                                        <ModalHapus changeHandler={this.changeHandler}
                                                            saveHandler={this.saveHandler}
                                                            CreateHandler={this.createHandler}
                                                            ShowModalDel={this.state.showModalDel}
                                                            CancelHandler={this.cancelHandler}
                                                            DeleteHandler2={this.deleteHandler2}
                                                            List={List}
                                                            Model={this.state.Model}
                                                        />
                                                        <ModalHapusList changeHandler={this.changeHandler}
                                                            saveHandler={this.saveHandler}
                                                            CreateHandler={this.createHandler}
                                                            ShowModalDel2={this.state.showModalDel2}
                                                            CancelHandler={this.cancelHandler}
                                                            List={List}
                                                            Model={this.state.Model}
                                                            ListDelete={this.state.ListDelete}
                                                            DeleteHandlerr2={this.deleteHandlerr2}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                </div>
            </div>
        )
    }
}